<template>
  <div>
    <div @click="onClick" @contextmenu.prevent="onConfig" v-long-press="onConfig">
      <material-stats-card v-bind="config">
        <template #actions v-if="actionIcon">
          <v-icon class="mr-2" small v-text="actionIcon" @click="onActionClick" />
          <div class="text-truncate">{{ actionText }}</div>
        </template>
      </material-stats-card>
    </div>
    <popup-modal ref="popup" :maxWidth="1200">
      <template v-slot:header>
        <v-btn icon style="position: absolute; top: 0px; right: 0px" @click="$refs.popup.close()"> <v-icon>mdi-close</v-icon> </v-btn>
      </template>

      <Table v-if="true" :data="detailData" :model="detailModel" :group="detailGroup" />
    </popup-modal>
  </div>
</template>
<script>
import { getAccess } from "@/components/mixings";
export default {
  mixins: [getAccess],
  components: {
    Table: () => import("./../components/table"),
  },
  props: {
    defaults: Object,
    model: { type: Object, default: () => {} },
  },
  data() {
    return {
      loading: false,
      data: [],
      value: null,
      api: null,
      actionIcon: null,
      actionText: null,
      showDetail: false,
      detailData: null,
      detailModel: null,
      detailGroup: null,
      componentId: null,
      touchTimer: null,
    };
  },
  created() {
    this.componentId = this.model.name;
    this.init();
  },
  computed: {
    refreshStamp() {
      if (!this.componentId) return false;
      return this.$store.state.state.refreshMap[this.componentId];
    },
    config() {
      let res = Object.assign({}, this.model.config);
      res.value = this.value;
      return res;
    },
  },
  watch: {
    refreshStamp() {
      this.init();
    },
  },
  methods: {
    onTouchStart(e) {
      this.touchTimer = setTimeout(() => {
        this.onConfig(e); // вызываем то же меню
      }, 600); // 500–700 мс — оптимально
    },
    onTouchEnd() {
      clearTimeout(this.touchTimer);
      this.touchTimer = null;
    },
    onConfig() {
      if (this.model.modelConfig) {
        this.$emit("config", this.model.modelConfig);
      }
    },
    getParam(n) {
      return this.$store.getters["config/getLocalParams"][n] || null;
    },
    onActionClick() {},
    onClick() {
      if (this.model.actions) {
        if (this.model.actions.click) {
          const a = this.model.actions.click;
          if (a.type == "route") {
            this.$router.push({ name: a.name, params: a?.params || {} });
          }

          if (a.type == "detail") {
            this.detailData = this.data;
            this.detailModel = this.model.detail.model;
            this.detailGroup = this.model.detail?.group || [];
            //this.showDetail = true;
            this.$refs.popup.open();
          }
          if (a.type == "refresh") {
            console.log("refresh");
            this.init();
          }
        }
      }
    },
    async init() {
      // console.log(new Date().weekStart);
      this.loading = true;
      if (this.model?.actions?.buttons) {
        this.actionIcon = this.model.actions.buttons[0].icon;
      }

      this.data = [];
      if (!this.model.type) return;
      let params = {};
      const user = { id: this.$root.profile.id };
      let resp;

      if (this.model.type == "badgeApi") {
        let type = "get";
        if (typeof this.model.api === "object") {
          this.api = this.model.api.api;
          if (this.model.api?.isAdmin) if (this.getAccess(this.model.api.isAdmin)) this.api += "_admin";
          type = this.model.api?.type || "get";
          //params = JSON.parse(this.model.api.params || "{}");
          //console.log("try eval", this.model.api.params);
          try {
            let p = this.model.api.params || {};
            //   console.log(this.model.name, p);
            if (typeof p !== "string") {
              p = JSON.stringify(params);
            }
            params = eval("(" + p + ")");
          } catch (error) {}
        }
        if (!this.api) return;
        this.loading = true;
        if (type == "get") {
          resp = await this.$axios.get(this.api, { params });
          this.data = resp;
        }
        if (type == "post") {
          resp = await this.$axios.post(this.api, params);
          this.data = resp.data.data;
        }
      } else if (this.model.type == "badge") {
      } else if (this.model.type == "tst") {
        let n = this.model.file; //"futureCashIncome";
        if (n == "futureCashIncome") {
          const { objectSchedule } = await import(`./../libs/${n}.js`);
          await objectSchedule(this);
        }
        if (n == "fff") {
          await this.calc2();
        }
      } else return;
      let value;
      if (typeof this.model.value === "object") {
        if (this.model.value.type == "function") {
          let f = this.model.value.func;
          value = eval(f)(this.data);
        }
      }
      this.value = value;
      this.loading = false;
    },
    async calc2() {
      try {
        let params = { name: "getObjectsBalance" };
        let res = await this.$axios.post("/report_sql", params);

        const objects = res.data.data;
        let data = [];
        for (let i = 0; i < objects.length; i++) {
          const o = objects[i];
          const b = JSON.parse(o.balance_calc);
          if (b.calc.type_90) data.push({ object_id: o.id, name: "Вложено средств компании", value: b.calc.type_90 });
          if (b.calc.type_22) data.push({ object_id: o.id, name: "Первоначальный взнос компании", value: b.calc.type_22 });
        }
        this.data = data;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.zebra tbody tr:nth-child(even) {
  background-color: #d8d8d8;
}
</style>
